import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Spinner, Badge } from "react-bootstrap";
import ModalConfirmar from "../../components/ModalConfirmar";
import { PERFILES } from "../../api/catalogosEstaticos";
import * as accesosApi from "../../api/accesos";
import * as menusApi from "../../api/menus";

/** Mantenimiento > Accesos: define qué puede VER/CREAR/EDITAR/BORRAR cada perfil, por menú. */
export default function AccesosMant() {
  const [accesos, setAccesos] = useState([]);
  const [menus, setMenus] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [aEliminar, setAEliminar] = useState(null);
  const [form, setForm] = useState({ perfilId: "", menuId: "", puedeVer: true, puedeCrear: false, puedeEditar: false, puedeBorrar: false });
  const [guardando, setGuardando] = useState(false);

  const cargar = async () => {
    setCargando(true);
    try {
      const [a, m] = await Promise.all([accesosApi.listarAccesos(), menusApi.listarMenus()]);
      setAccesos(a);
      setMenus(m);
    } finally { setCargando(false); }
  };

  useEffect(() => { cargar(); }, []);

  const abrir = (a) => {
    setEditando(a);
    setForm(a
      ? { perfilId: a.perfilId, menuId: a.menuId, puedeVer: a.puedeVer, puedeCrear: a.puedeCrear, puedeEditar: a.puedeEditar, puedeBorrar: a.puedeBorrar }
      : { perfilId: "", menuId: "", puedeVer: true, puedeCrear: false, puedeEditar: false, puedeBorrar: false });
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      await accesosApi.upsertAcceso({
        accesoId: editando?.accesoId ?? null,
        perfilId: Number(form.perfilId),
        menuId: Number(form.menuId),
        puedeVer: !!form.puedeVer,
        puedeCrear: !!form.puedeCrear,
        puedeEditar: !!form.puedeEditar,
        puedeBorrar: !!form.puedeBorrar,
      });
      setShowModal(false);
      cargar();
    } finally { setGuardando(false); }
  };

  const confirmarEliminar = async () => {
    await accesosApi.eliminarAcceso(aEliminar.accesoId);
    setAEliminar(null);
    cargar();
  };

  const check = (v) => <i className={`bi ${v ? "bi-check-circle-fill text-fs-ingreso" : "bi-dash-circle text-muted"}`}></i>;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Mantenimiento &gt; Accesos</h4>
        <Button size="sm" variant="primary" onClick={() => abrir(null)}><i className="bi bi-plus-lg me-1"></i>Nuevo acceso</Button>
      </div>

      {cargando ? <Spinner animation="border" /> : (
        <div className="fs-card p-0 overflow-hidden">
          <Table responsive hover className="table-fs table-fs-responsive mb-0 align-middle">
            <thead><tr><th>Perfil</th><th>Menú</th><th>Ver</th><th>Crear</th><th>Editar</th><th>Borrar</th><th></th></tr></thead>
            <tbody>
              {accesos.map((a) => (
                <tr key={a.accesoId}>
                  <td data-label="Perfil"><Badge bg={a.perfil === "Administrador" ? "dark" : "info"}>{a.perfil}</Badge></td>
                  <td data-label="Menú">{a.menu}</td>
                  <td data-label="Ver">{check(a.puedeVer)}</td>
                  <td data-label="Crear">{check(a.puedeCrear)}</td>
                  <td data-label="Editar">{check(a.puedeEditar)}</td>
                  <td data-label="Borrar">{check(a.puedeBorrar)}</td>
                  <td data-label="Acciones" className="text-end">
                    <Button size="sm" variant="outline-primary" className="me-1" onClick={() => abrir(a)}><i className="bi bi-pencil"></i></Button>
                    <Button size="sm" variant="outline-danger" onClick={() => setAEliminar(a)}><i className="bi bi-trash"></i></Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton><Modal.Title style={{ fontSize: "1.1rem" }}>{editando ? "Editar acceso" : "Nuevo acceso"}</Modal.Title></Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Perfil</Form.Label>
              <Form.Select value={form.perfilId} onChange={(e) => setForm({ ...form, perfilId: e.target.value })} required>
                <option value="">Selecciona...</option>
                {PERFILES.map((p) => <option key={p.perfilId} value={p.perfilId}>{p.nombre}</option>)}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Menú</Form.Label>
              <Form.Select value={form.menuId} onChange={(e) => setForm({ ...form, menuId: e.target.value })} required>
                <option value="">Selecciona...</option>
                {menus.map((m) => <option key={m.menuId} value={m.menuId}>{m.nombre}</option>)}
              </Form.Select>
            </Form.Group>
            <div className="d-flex gap-4 flex-wrap">
              <Form.Check label="Ver" checked={form.puedeVer} onChange={(e) => setForm({ ...form, puedeVer: e.target.checked })} />
              <Form.Check label="Crear" checked={form.puedeCrear} onChange={(e) => setForm({ ...form, puedeCrear: e.target.checked })} />
              <Form.Check label="Editar" checked={form.puedeEditar} onChange={(e) => setForm({ ...form, puedeEditar: e.target.checked })} />
              <Form.Check label="Borrar" checked={form.puedeBorrar} onChange={(e) => setForm({ ...form, puedeBorrar: e.target.checked })} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
            <Button type="submit" variant="primary" disabled={guardando}>{guardando ? <Spinner size="sm" animation="border" /> : "Guardar"}</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <ModalConfirmar show={!!aEliminar} titulo="Eliminar acceso" mensaje="¿Eliminar esta regla de acceso?"
        onConfirmar={confirmarEliminar} onCancelar={() => setAEliminar(null)} />
    </div>
  );
}
